import { Component, OnInit } from '@angular/core';
import {ValidateService} from '../../services/validate.service';
import {AuthService} from '../../services/auth.service';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Router} from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor( private validateService : ValidateService, 
   private flashMessagesService : FlashMessagesService,
   public authService: AuthService,
   private router :Router) { }

  ngOnInit() {
  }


onLogoutClick(){
this.authService.lougout();
this.flashMessagesService.show('vous etes deconnecter',{cssClass:'alert-success',timeout:3000});
this.router.navigate(['/login']);
return false;
	
}
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts